import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MembersService {
private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  featchUsers(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_users`, data);
  }

  addMembers(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/add_user`, formData);
  }

  editMembers(data: any) {
    return this.http.post(`${this.baseUrl}/edit_member`, data);
  }

  editUser(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/edit_user`, formData);
  }

  blockDropdown(data: any) {
 return this.http.post(`${this.baseUrl}/block_dropdown`, data);
}

floorDropdown(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_floor_dropdown`, data);
  }

  unitDropdown(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/floor_unit_dropdown`, data);
  }

  roleDropdown(): Observable<any> {
    return this.http.get(`${this.baseUrl}/role_dropdown`);
  }

  phaseDropdown(data: any): Observable<any> {
  return this.http.post(`${this.baseUrl}/phase_dropdown`, data);
}
}
